import React from "react";
import { Link, Outlet } from "react-router-dom";

const Seller = () => {
  return (
    <div>
      <ul className="menu p-4 w-80 bg-base-100 text-xl">
        <li className="mt-2">
          <Link to="/dashboard/seller/addproduct">Add Product</Link>
        </li>
        <li className="mt-2">
          <Link to="/dashboard/seller/myproduct">My Products</Link>
        </li>
      </ul>
      <Outlet />
    </div>
  );
};

export default Seller;
